export const CHECK_MOBILE = 'CHECK_MOBILE';
export const MOBILE_EXIST = 'MOBILE_EXIST';
export const MOBILE_NOT_EXIST = 'MOBILE_NOT_EXIST';

export const SEND_OTP = 'SEND_OTP';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const VERIFY_OTP = 'VERIFY_OTP';
export const OTP_VERIFICATION_FAILED = 'OTP_VERIFICATION_FAILED';
export const LOGGED_IN_SUCCESS = 'LOGGED_IN_SUCCESS';
export const CLEAR_AUTHENTICATION_DATA = 'CLEAR_AUTHENTICATION_DATA';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const SESSION_EXPIRED_RESET = 'SESSION_EXPIRED_RESET';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const USER_DETAILS = 'USER_DETAILS';
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS';

export const FETCH_CURRENT_COUNTRY = 'FETCH_CURRENT_COUNTRY';
export const FETCH_CURRENT_COUNTRY_SUCCESS = 'FETCH_CURRENT_COUNTRY_SUCCESS';

export const CITY_FOR_ZIP_CODE = 'CITY_FOR_ZIP_CODE';
export const CITY_FOR_ZIP_CODE_SUCCESS = 'CITY_FOR_ZIP_CODE_SUCCESS';
export const CITY_FOR_ZIP_CODE_FAILED = 'CITY_FOR_ZIP_CODE_FAILED';

export const FETCH_SPECIALITIES = 'FETCH_SPECIALITIES';
export const FETCH_SPECIALITIES_SUCCESS = 'FETCH_SPECIALITIES_SUCCESS';
export const FETCH_SPECIALITIES_FAILED = 'FETCH_SPECIALITIES_FAILED';

export const FETCH_QUALIFICATIONS = 'FETCH_QUALIFICATIONS';
export const FETCH_QUALIFICATIONS_SUCCESS = 'FETCH_QUALIFICATIONS_SUCCESS';
export const FETCH_QUALIFICATIONS_FAILED = 'FETCH_QUALIFICATIONS_FAILED';

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILED = 'FETCH_COUNTRIES_FAILED';

export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';

export const UPDATE_MOBILE = 'UPDATE_MOBILE';
export const UPDATE_MOBILE_SUCCESS = 'UPDATE_MOBILE_SUCCESS';
export const UPDATE_MOBILE_FAILED = 'UPDATE_MOBILE_FAILED';
export const UPDATE_MOBILE_REQUEST = 'UPDATE_MOBILE_REQUEST';

export const MOBILE_DETAILS = 'MOBILE_DETAILS';
export const CLEAR_MOBILE_DETAILS = 'CLEAR_MOBILE_DETAILS';

export const FETCH_LISTINGS = 'FETCH_LISTINGS';
export const FETCH_LISTINGS_SUCCESS = 'FETCH_LISTINGS_SUCCESS';

export const INITIATE_AUTHENTICATION = 'INITIATE_AUTHENTICATION';
export const STOP_AUTHENTICATION = 'STOP_AUTHENTICATION';
export const INITIATE_AUTH_DRAWER = 'INITIATE_AUTH_DRAWER';
export const STOP_AUTH_DRAWER = 'STOP_AUTH_DRAWER';

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILED = 'FETCH_PROFILE_FAILED';

export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILED = 'EDIT_PROFILE_FAILED';

export const FETCH_DOMAIN_DETAILS = 'FETCH_DOMAIN_DETAILS';
export const FETCH_DOMAIN_DETAILS_SUCCESS = 'FETCH_DOMAIN_DETAILS_SUCCESS';
export const FETCH_DOMAIN_DETAILS_FAILED = 'FETCH_DOMAIN_DETAILS_FAILED';
